import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {MatCheckboxChange} from "@angular/material/checkbox";

@Component({
  selector: 'app-frontend-check-box',
  standalone: false,
  templateUrl: './frontend-check-box.component.html',
  styleUrls: ['./frontend-check-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FrontendCheckBoxComponent {
  @Input()
  value?: boolean;
  @Input()
  title?: string;
  @Input()
  disabled: boolean = false;
  @Output()
  valueChange: EventEmitter<boolean> = new EventEmitter();

  onValueChange(event: any) {
    if (event instanceof MatCheckboxChange) {
      this.value = event.checked;
      this.valueChange.emit(this.value);
    }
  }
}
